import React, { useState, useRef, useEffect } from 'react';
import './GardenChat.css';
import api from '../services/api';
import GardenModal from './GardenModal';


function GardenChat() {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const chatKey = `gardenChatHistory_${user?.id || user?.email || 'guest'}`;
  console.log('GardenChat key:', chatKey, 'user:', user?.email);
  
  const [messages, setMessages] = useState(() => {
    const saved = localStorage.getItem(chatKey);
    if (saved) {
      try { return JSON.parse(saved); }
      catch (e) { return [{ role: 'assistant', content: 'Hi! I\'m your yard assistant. Ask me anything about plant care, lawn treatments, or your specific plants.' }]; }
    }
    return [{ role: 'assistant', content: 'Hi! I\'m your yard assistant. Ask me anything about plant care, lawn treatments, or your specific plants.' }];
  });
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState({ isOpen: false });
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  useEffect(() => {
    localStorage.setItem('chatKey', JSON.stringify(messages));
  }, [messages]);

  const handleSend = async (e) => {
    e.preventDefault();
    if (!input.trim() || loading) return;
    const userMessage = input.trim();
    setInput('');
    setMessages(prev => [...prev, { role: 'user', content: userMessage }]);
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await api.post(
        `${process.env.REACT_APP_API_URL}/chat`,
        { message: userMessage },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMessages(prev => [...prev, { role: 'assistant', content: response?.data?.message || 'Sorry, no response received.' }]);
    } catch (error) {
      console.error('GardenChat: send failed:', error);
      const errorMessage = error.response?.status === 504 || error.code === 'ECONNABORTED'
        ? 'The AI is taking longer than expected. Try a simpler question or try again.'
        : 'Sorry, I had trouble processing that. Please try again.';
      setMessages(prev => [...prev, { role: 'assistant', content: errorMessage }]);
    } finally {
      setLoading(false);
    }
  };

  const handleClearHistory = () => {
    setModal({
      isOpen: true, type: 'confirm', title: 'Clear History',
      message: 'Clear all chat history?',
      onConfirm: () => {
        const initial = [{ role: 'assistant', content: 'Hi! I\'m your yard assistant. Ask me anything about plant care, lawn treatments, or your specific plants.' }];
        setMessages(initial);
        localStorage.setItem('chatKey', JSON.stringify(initial));
        setModal({ isOpen: false });
      },
      onCancel: () => setModal({ isOpen: false })
    });
  };

  return (
    <div className="garden-chat-container">
      <GardenModal isOpen={modal.isOpen} type={modal.type} title={modal.title} message={modal.message} onConfirm={modal.onConfirm} onCancel={() => setModal({ isOpen: false })} />

      <div className="garden-chat-header">
        <h2>Yard Assistant</h2>
        <button
          onClick={handleClearHistory}
          className="garden-chat-clear-btn"
        >
          Clear History
        </button>
      </div>

      <div className="garden-chat-messages">
        {messages.map((msg, index) => (
          <div key={index} className={`chat-message-row chat-message-row--${msg.role}`}>
            <div className={`chat-bubble chat-bubble--${msg.role}`}>
              {msg.content}
            </div>
          </div>
        ))}
        {loading && (
          <div className="chat-message-row chat-message-row--assistant">
            <div className="chat-bubble chat-bubble--assistant">
              Thinking...
            </div>
          </div>
        )}
        <div ref={messagesEndRef} />
      </div>

      <form onSubmit={handleSend} className="garden-chat-form">
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Ask about watering, fertilizing, pest control..."
          disabled={loading}
          className="garden-chat-input"
        />
        <button
          type="submit"
          disabled={loading || !input.trim()}
          className="garden-chat-send-btn"
        >
          {loading ? 'Sending...' : 'Send'}
        </button>
      </form>

      <p className="garden-chat-tip">
        Tip: Ask specific questions like "When should I fertilize tomatoes?" or "How do I prevent aphids?"
      </p>
    </div>
  );
}

export default GardenChat;
